/** True when both emails are present and match case-insensitively. */
export const areDuplicateEmails = (
	mainEmail: string | undefined,
	coEmail: string | undefined
): boolean => {
	const main = mainEmail?.trim().toLowerCase();
	const co = coEmail?.trim().toLowerCase();

	if (!main || !co) {
		return false;
	}

	return main === co;
};
